export default {
  title: 'Informații de contact',
  form: {
    customer_first_name: {
      placeholder: 'Prenume',
    },
    customer_last_name: {
      placeholder: 'Nume de familie',
    },
    customer_email: {
      placeholder: 'Adresă de email',
    },
    customer_phone_number: {
      placeholder: 'Număr de telefon',
    },
  },
  validation: {
    customer_first_name: {
      required: 'Introdu prenumele',
    },
    customer_last_name: {
      required: 'Introdu numele de familie',
    },
    customer_email: {
      required: 'Introdu adresa de email',
    },
    customer_phone_number: {
      required: 'Introdu numărul de telefon',
    },
  },
};
